import React from 'react';
import {
  ButtonControl,
  IconControl,
} from 'spark-core-dx/components';

const formatTokenExpiry = (tokenExpiresAtUtc) => (
  tokenExpiresAtUtc
    ? ` Token expires ${new Date(tokenExpiresAtUtc).toLocaleString()}.`
    : ''
);

const ClientEntraSetupGuidance = ({
  canWrite,
  busy,
  setupComplete,
  onClientEmail,
  onEntraSetup,
  onRefresh,
  refreshEnabled,
  statusMessage,
  tokenExpiresAtUtc,
}) => (
  <section
    className="command-onboarding__phase-note command-onboarding__entra-guidance"
    aria-label="Microsoft Entra setup instructions"
  >
    <div className="command-onboarding__entra-guidance-header">
      <strong>Complete Microsoft Entra setup</strong>
      <div className="command-onboarding__entra-guidance-actions">
        <ButtonControl
          type="standard-small"
          onClick={onClientEmail}
        >
          Client Email
        </ButtonControl>
        <ButtonControl
          type="ok-small"
          onClick={onEntraSetup}
          disabled={!canWrite || busy}
        >
          Entra Setup
        </ButtonControl>
        <IconControl
          iconKey="refresh"
          title="Refresh setup status"
          aria-label="Refresh setup status"
          className="command-onboarding__entra-guidance-status-icon"
          width="1rem"
          height="1rem"
          onClick={refreshEnabled && !busy ? onRefresh : undefined}
        />
        <span
          className={[
            'command-onboarding__entra-guidance-status',
            setupComplete
              ? 'command-onboarding__entra-guidance-status--success'
              : 'command-onboarding__entra-guidance-status--warning',
          ].join(' ')}
          role="status"
        >
          {setupComplete ? 'Complete' : 'Pending'}
        </span>
      </div>
    </div>
    <ol>
      <li>
        Select <strong>Entra Setup</strong> to download the client-specific
        one-time PowerShell script. Existing tenant or application IDs entered
        above are reused; blank values are completed by the authorized tenant
        administrator and the script.
      </li>
      <li>
        Have an administrator for the client&apos;s Microsoft Entra tenant run
        the script with <code>-PlanOnly</code>, review the proposed changes,
        then run it normally and confirm <code>CONFIGURE</code>.
      </li>
      <li>
        The script resolves the tenant&apos;s initial verified domain, creates
        or reuses the sign-in and Graph Read applications, creates the
        protected credential, and posts the completed connection directly to
        Convoke. No secret is displayed or written to a result file. Convoke
        validates the connection server-side; no client user account or
        interactive login is required for this setup.
      </li>
    </ol>
    <p role="status">
      {statusMessage
        || 'Download a setup script when the client administrator is ready.'}
      {formatTokenExpiry(tokenExpiresAtUtc)}
    </p>
  </section>
);

export default ClientEntraSetupGuidance;
